import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

import { WidgetLayout } from '../widget-layout'

export type ConsumptionWidgetLayoutProps = {
    title: string
    loadingStatus?: boolean
    children: React.ReactNode | Array<React.ReactNode>
    className?: ClassName
    style?: React.CSSProperties
    dataTestId?: string
}

export function ConsumptionWidgetLayout({
    loadingStatus,
    title,
    children,
    className,
    style,
    dataTestId,
}: ConsumptionWidgetLayoutProps): React.ReactElement {
    return (
        <WidgetLayout
            className={cn(className)}
            style={style}
            data-testid={'widget-' + dataTestId}
            title={title}
            isLoading={loadingStatus}
        >
            {children}
        </WidgetLayout>
    )
}
